export function view(actionType) {
  switch (actionType) {
    case 'letter':
      return 'Letter'
    default:
      return 'No'
  }
}

export function getActionTitle(type) {
  switch (type) {
    case 'letter':
      return 'Generate a letter'
    default:
      return ''
  }
}
